import { Drawer, Grid, Layout } from "antd";
import { AppSuspense } from "components/App/AppSuspense";
import { AuthProvider } from "provider/AuthProvider";
import { useCallback, useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import { Navbar } from "./components/Navbar";
import { PageBreadcrumb } from "./components/PageBreadcrumb";
import { SIDENAV_WIDTH, SidebarMenu } from "./components/Sidebar";
import "./styles/AdminLayout.scss";

const { Content } = Layout;
const { useBreakpoint } = Grid;

export const AdminLayout = () => {
  const screens = useBreakpoint();
  const isMobile = !screens.md;

  const [mobileDrawerOpen, setMobileDrawerOpen] = useState(false);

  const toggle = useCallback(() => {
    setMobileDrawerOpen((prev) => !prev);
  }, []);

  const closeMobileDrawer = useCallback(() => {
    setMobileDrawerOpen(false);
  }, []);

  useEffect(() => {
    if (!isMobile) {
      setMobileDrawerOpen(false);
    }
  }, [isMobile]);

  return (
    <AppSuspense>
      <AuthProvider>
        <Layout>
          <Drawer
            title={null}
            placement="left"
            closable={false}
            onClose={closeMobileDrawer}
            open={isMobile && mobileDrawerOpen}
            width={SIDENAV_WIDTH}
            className="admin-sidebar-drawer"
            styles={{ body: { padding: 0 } }}
          >
            <SidebarMenu onNavigate={closeMobileDrawer} />
          </Drawer>

          <Layout className={`site-layout${isMobile ? " site-layout--mobile" : ""}`}>
            <Navbar toggle={toggle} isMobile={isMobile} />

            <PageBreadcrumb />

            <Content className="site-layout-background admin-page-content">
              <Outlet />
            </Content>
          </Layout>
        </Layout>
      </AuthProvider>
    </AppSuspense>
  );
};
